var map = {
	"./ar.json": 5310,
	"./chi.json": 58601,
	"./en.json": 44174,
	"./fr.json": 94605,
	"./gr.json": 76924,
	"./hi.json": 53134,
	"./sp.json": 56690
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81266;